import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import FamilyMemberStep from "../FamilyMemberStep";
import { bookingFlowStore } from "../../store/BookingFlowStore";

interface Step9Props {
  onSelectFamilyMember: (member: any) => void;
  onOpenCreateFamilyMemberModal: () => void;
}

const Step9_FamilyMember: React.FC<Step9Props> = ({
  onSelectFamilyMember,
  onOpenCreateFamilyMemberModal,
}) => {
  const isForFamilyMember = !bookingFlowStore.appointmentData.isForUser;
  const selectedFamilyMember = bookingFlowStore.appointmentData.selectedFamilyMember;

  if (!isForFamilyMember || selectedFamilyMember) return null;

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
    >
      
      <Text fontSize="lg" fontWeight="bold" mb={4}>
        Select your Family Member
      </Text>
      <FamilyMemberStep
        onSelectFamilyMember={onSelectFamilyMember}
        onOpenCreateFamilyMemberModal={onOpenCreateFamilyMemberModal}
      />
    </Flex>
  );
};

export default Step9_FamilyMember;
